import React, { ReactNode } from 'react';

import { IBasicStyledProps } from '@notino/react-styleguide-v20';

import { AlignedInfoMark } from '@styles/cartComponents';
import { ReactFCV } from '@types';

import { StyledGeneralTextService, StyledTitleExtended, StyledTitle } from './styled';

export interface IGeneralTextServiceProps extends IBasicStyledProps {
  title: string | ReactNode;
  titleExtended?: string;
  infoMarkText?: string;
}

export const GeneralTextService: ReactFCV<IGeneralTextServiceProps> = ({ title, titleExtended, infoMarkText }) => {
  return (
    <div>
      <StyledGeneralTextService>
        <StyledTitle>{title}</StyledTitle>
        {titleExtended && <StyledTitleExtended> {titleExtended}</StyledTitleExtended>}
      </StyledGeneralTextService>
      {infoMarkText && <AlignedInfoMark content={infoMarkText} />}
    </div>
  );
};
